import { Typography, useMediaQuery, useTheme } from '@mui/material'

import { LocaleSelect } from '../code-card'
import { useStyles } from './styles'

interface IProps {
  title: string
  locale?: string
  handleLocale?: (locale: string) => void
  headerCode?: string
}

export const LocaleHeaderTitle = ({ title, locale, handleLocale, headerCode }: IProps) => {
  const theme = useTheme()
  const classes = useStyles()
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))
  return (
    <div className={classes.headerWrapper}>
      <div>
        <Typography className={classes.headerTitle}>{title}</Typography>
        {headerCode && isMobile && <div className={classes.headerCode}>{headerCode}</div>}
      </div>
      {locale && handleLocale && (
        <div className={classes.localWrapper}>
          <LocaleSelect locale={locale} handleLocale={handleLocale} />
        </div>
      )}
    </div>
  )
}
